import React from 'react';

import SvgIcon from './SvgIcon';

const Facebook = props => (
    <SvgIcon {...props}>
        <g id="F" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <path
                d="M5.93765509,16.1646 L5.93765509,9.27927194 L3.10165114,9.27927194 L3.10165114,6.24069627 L5.93765509,6.24069627 L5.93765509,4.21497916 C5.93765509,1.58260198 7.55822878,0.1646 9.98908932,0.1646 C11.2034645,0.1646 12.2163231,0.1646 12.4199499,0.367171711 L12.4199499,3.20317567 L10.7983211,3.20317567 C9.38137418,3.20317567 9.17774741,3.8108908 9.17774741,4.8226943 L9.17774741,6.24069627 L13.0266099,6.24069627 L12.0137514,9.27927194 L9.17774741,9.27927194 L9.17774741,16.1646 L5.93765509,16.1646 Z"
                id="Fill-1"
                fill="#FFFFFF"
            ></path>
        </g>
    </SvgIcon>
);

Facebook.displayName = 'FacebookIcon';

export default Facebook;
